import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ApplicationsModal = ({ className }) => (
  <div className={className}>ApplicationsModal</div>
);

ApplicationsModal.propTypes = { className: PropTypes.string.isRequired };

export default styled(ApplicationsModal)`
  z-index: 3;
`;
